import Vue from 'vue';
import Vuex from 'vuex';

// import axios from 'axios';
// import fetchService from '@/services/fetchService';

import * as jobPost from './modules/jobPost';
import * as user from './modules/user';
import * as candidate from './modules/candidate';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    jobPost,
    user,
    candidate,
  },
});
